import Vue from "vue";
import Vuex from "vuex";
import AlbumModule from "./modules/album";
import AdminModule from "./modules/admin";
import AlbumCreatorModule from "./modules/albumCreator";
import AppModule from "./modules/app";
import CreatorModule from "./modules/creator";
import FileUploadModule from "./modules/fileUpload";
import PlayerModule from "./modules/player";
import ProductsModule from "./modules/products";
import SongModule from "./modules/song";
import StatsModule from "./modules/stats";
import UserModule from "./modules/user";
import NavigationModule from "./modules/navigation";
import TagModule from "./modules/tag";
import * as R from "ramda";

Vue.use(Vuex);

const initialState = {
  admin: R.clone(AdminModule.state),
  album: R.clone(AlbumModule.state),
  app: R.clone(AppModule.state),
  user: R.clone(UserModule.state),
  player: R.clone(PlayerModule.state),
  song: R.clone(SongModule.state),
  stats: R.clone(StatsModule.state),
  creator: R.clone(CreatorModule.state),
  products: R.clone(ProductsModule.state),
  fileUpload: R.clone(FileUploadModule.state),
  albumCreator: R.clone(AlbumCreatorModule.state),
  navigation: R.clone(NavigationModule.state),
  tag: R.clone(TagModule.state)
};

const modulesToReset = [
  "user",
  "song",
  "album",
  "creator",
  "fileUpload",
  "albumCreator"
];

export default new Vuex.Store({
  modules: {
    admin: AdminModule,
    album: AlbumModule,
    app: AppModule,
    user: UserModule,
    player: PlayerModule,
    song: SongModule,
    stats: StatsModule,
    creator: CreatorModule,
    products: ProductsModule,
    fileUpload: FileUploadModule,
    albumCreator: AlbumCreatorModule,
    navigation: NavigationModule,
    tag: TagModule
  },
  mutations: {
    reset(state) {
      Object.keys(state).forEach(key => {
        if (modulesToReset.indexOf(key) !== -1) {
          Object.assign(state[key], initialState[key]);
        }
      });
    }
  }
});
